var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.5663 35.6942V26.3462C80.5663 25.8503 80.3692 25.3748 80.0188 25.0242C79.6681 24.6735 79.1925 24.4766 78.6966 24.4766H50.6523V95.5213H78.6966C79.1925 95.5213 79.6681 95.3243 80.0188 94.9739C80.3692 94.6232 80.5663 94.1475 80.5663 93.6517V84.3037",
    fill: "#F3F7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5663 35.6942V26.3462C80.5663 25.8503 80.3692 25.3748 80.0188 25.0242C79.6681 24.6735 79.1925 24.4766 78.6966 24.4766H50.6523V95.5213H78.6966C79.1925 95.5213 79.6681 95.3243 80.0188 94.9739C80.3692 94.6232 80.5663 94.1475 80.5663 93.6517V84.3037",
    stroke: "#173261",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103 60H58.1289",
    stroke: "#173261",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.043 74.9526L103 59.9959L88.043 45.0391",
    stroke: "#173261",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 94.483C17.0002 94.9085 17.1455 95.3213 17.412 95.653C17.6785 95.9846 18.0503 96.2157 18.4658 96.3077L48.3797 102.956C48.6529 103.016 48.9361 103.015 49.2085 102.951C49.4809 102.888 49.7357 102.764 49.9538 102.588C50.172 102.413 50.3481 102.192 50.4691 101.939C50.5902 101.687 50.6531 101.411 50.6532 101.131V18.8689C50.6531 18.5891 50.5902 18.3129 50.4691 18.0607C50.3481 17.8085 50.172 17.5867 49.9538 17.4116C49.7357 17.2365 49.4809 17.1125 49.2085 17.0489C48.9361 16.9853 48.6529 16.9837 48.3797 17.0441L18.4658 23.6924C18.0503 23.7844 17.6785 24.0153 17.412 24.3471C17.1455 24.6788 17.0002 25.0916 17 25.5172V94.483Z",
    fill: "#D1D5DF",
    stroke: "#173261",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39 65C41.7614 65 44 62.7613 44 60C44 57.2387 41.7614 55 39 55C36.2386 55 34 57.2387 34 60C34 62.7613 36.2386 65 39 65Z",
    fill: "#F3F7FF",
    stroke: "#173261",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/Exit.baba11190dac0fad07bb966cebf78b47.svg";
export { ForwardRef as ReactComponent };